import { NodeSelection, TextSelection } from '@atlaskit/editor-prosemirror/state';
import { findParentNodeOfType } from '@atlaskit/editor-prosemirror/utils';
import { Decoration, DecorationSet } from '@atlaskit/editor-prosemirror/view';
import { CellSelection, findTable, TableMap } from '@atlaskit/editor-tables';
import { getSelectionRect } from '@atlaskit/editor-tables/utils';
import { ACTIONS, decorationStateKey } from './main';
export var hoverDecorationCommand = function hoverDecorationCommand(_ref) {
  var nodeType = _ref.nodeType,
    add = _ref.add,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'danger' : _ref$className;
  return function (_ref2) {
    var tr = _ref2.tr;
    var from;
    var parentNode;
    var decoration;
    if (tr.selection instanceof NodeSelection) {
      var selectedNode = tr.selection.node;
      var nodeTypes = Array.isArray(nodeType) ? nodeType : [nodeType];
      var isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
      // This adds danger styling if the selected node is the one that requires
      // the decoration to be added, e.g. if a layout is selected and the user
      // hovers over the layout's delete button.
      if (isNodeTypeMatching) {
        from = tr.selection.from;
        parentNode = selectedNode;
      }
    }

    // This adds danger styling if the selection is not a node selection, OR if
    // the selected node is a child of the one that requires the decoration to
    // be added, e.g. if a decision item is selected inside a layout and the
    // user hovers over the layout's delete button.
    var foundParentNode = findParentNodeOfType(nodeType)(tr.selection);
    if (from === undefined && foundParentNode) {
      from = foundParentNode.pos;
      parentNode = foundParentNode.node;
    }

    // Note: can't use !from as from could be 0, which is falsy but valid
    if (from === undefined || parentNode === undefined) {
      return tr;
    }
    decoration = Decoration.node(from, from + parentNode.nodeSize, {
      class: className
    }, {
      key: 'decorationNode'
    });
    if (tr.selection instanceof TextSelection) {
      decoration = Decoration.inline(from, tr.selection.to, {
        class: className,
        style: "background-color: ".concat("var(--ds-background-danger, #FFECEB)", ";")
      }, {
        key: 'decorationNode'
      });
    }
    if (tr.selection instanceof CellSelection) {
      var table = findTable(tr.selection);
      if (!table) {
        return tr;
      }
      var map = TableMap.get(table.node);
      var rect = getSelectionRect(tr.selection);
      if (!map || !rect) {
        return tr;
      }
      var updatedCells = map.cellsInRect(rect).map(function (x) {
        return x + table.start;
      });
      var tableCellDecorations = updatedCells.map(function (pos) {
        var cell = tr.doc.nodeAt(pos);
        if (!cell) {
          return;
        }
        return Decoration.node(pos, pos + cell.nodeSize, {
          class: className
        }, {
          key: 'decorationNode'
        });
      }).filter(function (decoration) {
        return !!decoration;
      });
      decoration = DecorationSet.create(tr.doc, tableCellDecorations);
    }
    tr.setMeta(decorationStateKey, {
      action: add ? ACTIONS.DECORATION_ADD : ACTIONS.DECORATION_REMOVE,
      data: decoration
    }).setMeta('addToHistory', false);
    return tr;
  };
};
export var removeDecorationCommand = function removeDecorationCommand() {
  return function (_ref3) {
    var tr = _ref3.tr;
    return tr.setMeta(decorationStateKey, {
      action: ACTIONS.DECORATION_REMOVE
    });
  };
};